import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '../../../global/components/logo/logo.component';
import { LOGO } from '../../../../helpers/constants';

@Component({
  selector: 'app-no-job-id-page',
  standalone: true,
  imports: [CommonModule, LogoComponent],
  templateUrl: './no-job-id-page.component.html',
  styleUrl: './no-job-id-page.component.css'
})
export class NoJobIdPageComponent {
  logo: string = LOGO;
  noJobId: string = "Oops! We can't find your Service Appointment";
}
